export default __webpack_public_path__ + "static/stile_x_timelapse-0f36199294af76bf98f3a1f83c7f90f7.mp4";